export const socials = [
    {
        icon: "instagram",
        href: "https://www.instagram.com/keel.mind/",
    },
    {
        icon: "linkedin",
        href: "https://www.linkedin.com/company/geta-head/",
    },
];
